import { render, staticRenderFns } from "./ComplaintDetailEvent.vue?vue&type=template&id=6bab6ab4&scoped=true"
import script from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetailEvent.vue?vue&type=style&index=0&id=6bab6ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab6ab4",
  null
  
)

export default component.exports